import { useNavigate } from "react-router-dom";
import { Button, Flex, Typography, Card } from "antd";
import { useCategories } from "../../../../hooks";
import EditCategoryForm from "../../components/edit-category.form";
import CreateCategoryForm from "../../components/create-category.foms";

export const AdminCategoriesView = () => {
  const navigate = useNavigate();
  const { categories, loading, deleteCategory, refetch } = useCategories();

  return (
    <div>
      <Flex wrap gap="small" align="center">
        <Typography.Title level={2}>Gestión de Categorías</Typography.Title>
        <CreateCategoryForm
          onSubmit={(values) => {
            console.log({ values });
            refetch();
          }}
        />
      </Flex>

      <Flex wrap gap="small">
        {loading && <div>Loading...</div>}
        {categories &&
          categories.map((category) => (
            <Card
              key={category.id}
              hoverable
              style={{ width: "100%", maxWidth: "350px", margin: "auto" }}
              cover={
                <img
                  alt={category.name}
                  src={category.image || "/broken-image.png"}
                  style={{ height: 220, objectFit: "cover" }}
                />
              }
              actions={[
                <EditCategoryForm
                  categoryId={category.id}
                  onSubmit={(values) => {
                    refetch();
                  }}
                />,
                <Button
                  key="delete"
                  onClick={async () => {
                    await deleteCategory({ category });
                    refetch();
                  }}
                >
                  Eliminar
                </Button>,
                <Button
                  key="typologies"
                  onClick={() =>
                    navigate(`/admin/category/${category.id}/typologies`)
                  }
                >
                  Tipologías
                </Button>,
              ]}
            >
              <Card.Meta
                title={category.name}
                description={`${category.type} - ${category.description}`}
              />
            </Card>
          ))}
      </Flex>
    </div>
  );
};
